import api from 'store/services/api';

export const fetchInProgressPaymentsService = () =>
  api(
    `/api/v1/iugu_iugureviewerfinancialaccounts/get_in_progress_reviews_per_user/`,
  );
